<form [formGroup]="form" autocomplete="off">
  <div class="row">
    <!-- dynamicTemplateId -->
    <div class="tw-w-full">
      <dynamic-template-select-search
        class="tw-mt-4"
        [label]="'common.dynamicTemplate'"
        [control]="form?.get('dynamicTemplateId')"
        [(value)]="detail.dynamicTemplateId"
      >
      </dynamic-template-select-search>
    </div>

    <!-- SentDelayType & SentDelayValue-->
    <div class="tw-w-full">
      <app-periodic-type
        [config]="periodicTypeConfig"
        (periodType)="detail.delayType = $event"
        (periodText)="detail.delayValue = $event"
      >
      </app-periodic-type>
    </div>
    <!--sms body & privateNumber -->
    <div class="tw-w-full">
      <app-sms-body
        [form]="form"
        [isEditMode]="formPageConfig.isEditMode"
        smsBodyControlName="smsBody"
        senderNumberControlName="privateNumberId"
        [sendType]="SendTypes.Device"
        [isAddSignature]="false"
        [organizationId]="formPageConfig.isEditMode ? input_organizationId : ''"
        [userId]="formPageConfig.isEditMode ? input_userId : ''"
        [isAddHeader]="false"
        [senderNumberId]="detail.privateNumberId"
        [smsBody]="detail.smsText"
        (finalSmsBody)="detail.smsText = $event"
        (senderNumberId)="detail.privateNumberId = $event"
      >
      </app-sms-body>
    </div>

    <!-- isActive -->
    <div class="tw-w-full">
      <mat-slide-toggle
        formControlName="isActive"
        [(ngModel)]="detail.isActive"
      >
        {{ "common.isActive" | translate }}</mat-slide-toggle
      >
    </div>
  </div>
</form>
